import { motion } from "framer-motion";
import { SectionHeader } from "@/components/sections/SectionHeader";

const STEPS = [
  { n: "01", title: "Alegem ingrediente bune", desc: "Făină atent selectată, unt, ouă și ingrediente fără compromisuri. De aici începe gustul." },
  { n: "02", title: "Lucrăm aluatul cu grijă", desc: "Frământare, dospire, modelare. Fără grabă. Aluatul vrea timp, iar noi i-l dăm." },
  { n: "03", title: "Respectăm timpii și procesul", desc: "Rețete verificate, etape stricte. Așa iese același produs bun, lot după lot." },
  { n: "04", title: "Coacem sau congelăm corect", desc: "Tehnologie potrivită pentru fiecare produs. Coacere completă sau congelare care păstrează totul." },
  { n: "05", title: "Livrăm pregătit pentru afacerea ta", desc: "Ambalat curat, ușor de gestionat, gata să intre direct în fluxul tău de bucătărie." },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="section-pad bg-surface-2/40 border-y border-border">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Procesul nostru"
          title="De la aluat la vitrină, fără compromis."
          subtitle="Nu promitem magie. Promitem muncă bună, rețete verificate și seriozitate."
          align="center"
          testId="process-header"
        />

        <div className="mt-16 relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/40 to-transparent" />
          <div className="space-y-12 md:space-y-16">
            {STEPS.map((s, i) => {
              const isRight = i % 2 === 1;
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.05 * i }}
                  className={`relative grid md:grid-cols-2 gap-6 items-center ${isRight ? "" : ""}`}
                  data-testid={`process-step-${i}`}
                >
                  <div className={`${isRight ? "md:order-2" : ""}`}>
                    <div className="card-soft p-7 max-w-md">
                      <div className="font-display text-5xl md:text-6xl shimmer-text leading-none">{s.n}</div>
                      <h3 className="mt-4 font-display text-xl md:text-2xl text-text">{s.title}</h3>
                      <p className="mt-2 text-sm md:text-base text-text-soft leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                  {/* center dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 h-4 w-4 rounded-full bg-gold shadow-[0_0_0_6px_hsl(var(--gold)/0.15)]" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
